import { DropdownFiltersType } from 'types/dropdownFilters';
import { Parameters } from 'constants/queryParameters';
import { CheckboxFilter } from 'components/Table/Table.types';

export const HeaderFilters: { checkboxes: CheckboxFilter[] } = {
  checkboxes: [
    {
      filterKey: Parameters.displaySepIra,
      label: 'Show employer accounts',
    },
    {
      filterKey: Parameters.onlyFunded,
      label: 'Show accounts with a balance greater than $0.00',
    },
    {
      filterKey: Parameters.accountClosed,
      label: 'Show only closed accounts',
    },
  ],
};

export const DropdownFilters: DropdownFiltersType = {
  profileStatus: {
    name: 'Status',
    filterKey: Parameters.status,
    options: [
      ['draft', 'Draft'],
      ['invited', 'Invited'],
      ['accepted', 'Accepted'],
      ['active', 'Active'],
      ['accountProcessing', 'Account Processing'],
      ['accountCreationFailed', 'Account Creation Failed'],
    ],
  },
  userProfileType: {
    name: 'Account type',
    filterKey: Parameters.userProfileType,
    options: [
      ['sepIra', 'SEP IRA (employee)'],
      ['sepFreelancer', 'SEP IRA (freelancer)'],
      ['simpleIra', 'SIMPLE IRA'],
      ['solo401kFreelancer', 'Solo 401(k)'],
      ['traditional', 'Traditional'],
      ['roth', 'Roth'],
      ['inheritedTraditional', 'Inherited Traditional'],
      ['inheritedRoth', 'Inherited Roth'],
      ['hsa', 'HSA'],
      ['esa', 'ESA'],
      ['rothSolo401k', 'Roth Solo 401(k)'],
      ['rothSepIra', 'Roth SEP IRA'],
      ['rothSimpleIra', 'Roth SIMPLE IRA'],
      ['corporate401kSubAccount', 'Corporate 401k Sub-account'],
    ],
  },
  custodianType: {
    name: 'Custodian',
    filterKey: Parameters.custodianType,
    options: [
      ['iraClub', 'IRA Club'],
      ['solera', 'Solera'],
      ['madisonTrust', 'Madison Trust'],
      ['advantaIra', 'Advanta IRA'],
      ['entrust', 'Entrust'],
      ['forgeTrust', 'Forge Trust'],
      ['iPlanGroup', 'iPlan Group'],
      ['cnbCustody', 'CNB Custody'],
      ['inspira', 'Inspira'],
      ['mountainWestIra', 'Mountain West IRA'],
      ['midAtlanticIra', 'MidAtlantic IRA'],
      ['horizonTrust', 'Horizon Trust'],
      ['nextGenTrust', 'Next Gen Trust'],
      ['camaPlan', 'CamaPlan'],
    ],
  },
};
